import React, { Fragment } from 'react';
import classNames from 'classnames';

import * as ProdRecordHelpers from 'Pages/manageproduction/helpers/productionRecord';
import { ProductionRecordFieldEnum as ProdRecordFields } from 'Common/FieldEnum';
import { InputMode } from 'Common/FormEnum';

import { GridInputCell } from './GridInputCell';

function PlannedSectionHeaderRow(props) {
  const {
    recipeCategoryId,
    collapsed,
    isReadOnly,
    onInputChange,
    feedingFigure,
    feedingFigureAdult,
    feedingFigureAlacarte,
    reimbTotalsByRecCat,
    plannedPercByRecCat,
    plannedPercMessagesByRecCat,
    plannedAlacarteByRecCat,
    plannedAdultByRecCat,
    plannedTotalByRecCat,
    plannedPreKByRecCat,
  } = props;

  let reimbCol;
  let alacarteCol;
  let plannedAdultCol;
  const plannedPercentage = plannedPercByRecCat[recipeCategoryId];

  if (ProdRecordHelpers.isEntree(recipeCategoryId)) {
    reimbCol = (
      <GridInputCell
        inputProps={{
          name: ProdRecordFields.FeedingFigure,
          disabled: isReadOnly,
          onChange: onInputChange,
          value: feedingFigure,
        }}
        mode={InputMode.Integer}
      />
    );
    alacarteCol = (
      <GridInputCell
        inputProps={{
          name: ProdRecordFields.FeedingFigureAlacarte,
          disabled: isReadOnly,
          value: feedingFigureAlacarte,
          onChange: onInputChange,
        }}
        mode={InputMode.Integer}
      />
    );
    plannedAdultCol = (
      <GridInputCell
        inputProps={{
          name: ProdRecordFields.FeedingFigureAdult,
          onChange: onInputChange,
          disabled: isReadOnly,
          value: feedingFigureAdult,
        }}
        mode={InputMode.Integer}
      />
    );    
  } else {
    reimbCol = (
      <div className="grid-item blue">
        {reimbTotalsByRecCat[recipeCategoryId]}
      </div>
    );
    alacarteCol = (
      <div className="grid-item blue">
        {plannedAlacarteByRecCat[recipeCategoryId]}
      </div>
    );
    plannedAdultCol = (
      <div className="grid-item blue">
        {plannedAdultByRecCat[recipeCategoryId]}
      </div>
    );    
  }

  if (ProdRecordHelpers.isMilk(recipeCategoryId)) {
    reimbCol = <div className="grid-item blue">{feedingFigure}</div>;
  }

  return (
    <Fragment>
      {reimbCol}
      {!collapsed && (
        <Fragment>
          <div
            className={classNames('grid-item', {
              'percentage green': !ProdRecordHelpers.shouldShowRedPercentage(
                recipeCategoryId,
                plannedPercentage
              ),
              'percentage red': ProdRecordHelpers.shouldShowRedPercentage(
                recipeCategoryId,
                plannedPercentage
              ),
            })}
          >
            {plannedPercMessagesByRecCat[recipeCategoryId]}
          </div>
          <div className="grid-item blue">
            {plannedPreKByRecCat[recipeCategoryId]}
          </div>
          {alacarteCol}
          {plannedAdultCol}
          <div className="grid-item blue">
            {plannedTotalByRecCat[recipeCategoryId]}
          </div>
          <div />
          <div />
        </Fragment>
      )}
    </Fragment>
  );
}

const MemoizedPlannedSectionHeaderRow = React.memo(PlannedSectionHeaderRow);

export { MemoizedPlannedSectionHeaderRow as PlannedSectionHeaderRow };



// WEBPACK FOOTER //
// ./src/pages/manageproduction/subpages/editproduction/components/PlannedSectionHeaderRow.js